import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const styles = {
  footer: css`
    padding-top: ${theme.spacing(2)};
    padding-bottom: ${theme.spacing(2)};
    text-align: center;
    margin-top: ${theme.spacing(2)};
    a {
      text-decoration: none;
      color: ${theme.font.colors.subdued};
    }
    a:hover {
      color: ${theme.font.colors.default};
    }
  `,
};

export const PrivacyPolicyWrapper = ({ children }: { children: ReactNode }) => {
  return <div css={styles.footer}>'{children}</div>;
};
